"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsLoggedIn = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

/**
 * @name getIsLoggedIn
 * @description - Function to determine logged in status.
 * @returns {Promise<boolean>} - returns true if a user is logged in
 */
var getIsLoggedIn = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var _window$webShellClien, _window$webShellClien2, _window$webShellClien3, _window$webShellClien4;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if ((_window$webShellClien = window.webShellClient) !== null && _window$webShellClien !== void 0 && (_window$webShellClien2 = _window$webShellClien.identity) !== null && _window$webShellClien2 !== void 0 && _window$webShellClien2.getIsLoggedIn) {
              _context.next = 2;
              break;
            }

            throw new Error('Error happened while accessing Web Shell Client - Identity');

          case 2:
            _context.next = 4;
            return (_window$webShellClien3 = window.webShellClient) === null || _window$webShellClien3 === void 0 ? void 0 : (_window$webShellClien4 = _window$webShellClien3.identity) === null || _window$webShellClien4 === void 0 ? void 0 : _window$webShellClien4.getIsLoggedIn();

          case 4:
            return _context.abrupt("return", _context.sent);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getIsLoggedIn() {
    return _ref.apply(this, arguments);
  };
}();

exports.getIsLoggedIn = getIsLoggedIn;